/**
 * Task API — typed wrappers around legacy taskApi.js.
 */
import {
  addTask as legacyAddTask,
  addAudioTask as legacyAddAudioTask,
  addVideoTask as legacyAddVideoTask,
  editVideoTask as legacyEditVideoTask,
  getProjectTasks as legacyGetProjectTasks,
  addMessageToTask as legacyAddMessageToTask,
  deleteTask as legacyDeleteTask,
} from '../apiServices/taskApi';

import type { RawApiResponse } from './project';

export async function getProjectTasks(projectId: string): Promise<RawApiResponse> {
  return legacyGetProjectTasks(projectId);
}

export async function addTask(data: Record<string, unknown>): Promise<unknown> {
  return legacyAddTask(data);
}

export async function addAudioTask(
  parent: string,
  type: string,
  index: number,
  resource: string,
  message: string,
  timestamp: number,
): Promise<unknown> {
  return legacyAddAudioTask(parent, type, index, resource, message, timestamp);
}

export interface VideoTaskParams {
  parent: string;
  type: string;
  index: number;
  resource: string;
  message: string;
  coordX: number;
  coordY: number;
  timestamp: number;
  snapshotThumbnailStorage?: string;
  taskType?: string;
  duration?: number;
  coords?: { x: number; y: number } | null;
}

export async function addVideoTask(params: VideoTaskParams): Promise<unknown> {
  return legacyAddVideoTask(params);
}

export async function editVideoTask(params: {
  id: string;
  duration?: number;
  status?: string;
  tasktype?: string;
}): Promise<unknown> {
  return legacyEditVideoTask(params);
}

export async function addMessageToTask(taskId: string, message: string): Promise<unknown> {
  return legacyAddMessageToTask(taskId, message);
}

export async function deleteTask(taskId: string, projectId: string): Promise<unknown> {
  return legacyDeleteTask(taskId, projectId);
}
